export default "__VITE_ASSET__BKnlYH9w__"